// Cave84 — App entry (Phase 0 Day 3)
// Top-level switch between the loading placeholder, LoginScreen, and the
// authenticated RouterProvider. Until auth resolves we render a minimal
// loading state. Once authenticated we hand off entirely to react-router.

import { RouterProvider } from 'react-router-dom';
import { useAuthBootstrap } from '@/hooks/useAuth';
import { useAuthStore } from '@/stores/auth.store';
import { LoginScreen } from '@/components/LoginScreen';
import { PwaUpdateToast } from '@/components/PwaUpdateToast';
import { router } from '@/router';

export default function App() {
  useAuthBootstrap();
  const status = useAuthStore((s) => s.status);

  if (status === 'initializing') {
    return (
      <div className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="text-text-tertiary smallcaps animate-pulse">Loading…</div>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <LoginScreen />;
  }

  return (
    <>
      <RouterProvider router={router} />
      {/* Rendered outside the router so it survives route transitions */}
      <PwaUpdateToast />
    </>
  );
}
